import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";

async function getInsightsAPIKey() {
  return await httpClient.core.get<string>(`/api-key/insights`, {
    responseType: "text",
  });
}

export const useGetInsightsAPIKey = () => {
  return useQuery({
    queryKey: ["insights-api-key"],
    queryFn: getInsightsAPIKey,
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60, // 1 hour
  });
};
